import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { AnalyticsService } from '../../shared/analytics.service';
import { RegistrationSharedService } from '../registration-shared.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import confetti from 'canvas-confetti';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { TranslocoDirective } from '@jsverse/transloco';
import { IconCalendarComponent } from '@pedix-workspace/angular-ui-icons';
import { environment } from '../../../../environments/environment';
@Component({
    selector: 'app-step-success',
    templateUrl: './step-success.component.html',
    styleUrls: ['./step-success.component.scss'],
    imports: [TranslocoDirective, ButtonComponent, AlertComponent, IconCalendarComponent]
})
export class StepSuccessComponent implements OnInit, AfterViewInit {
  private registrationSharedService = inject(RegistrationSharedService);
  private analyticsService = inject(AnalyticsService);
  private deviceService = inject(DeviceDetectorService);

  constructor() {}

  ngOnInit() {
    this.analyticsService.createSubscription();
  }

  ngAfterViewInit(): void {
    if (!this.deviceService.isMobile()) {
      this.createConfetti();
    }
  }

  async finishRegistration() {
    const username = this.registrationSharedService.registrationData.account?.username;
    if (username) {
      location.href = `${environment.siteUrl}/acceso?username=${encodeURIComponent(username)}`;
    }
  }

  createConfetti() {
    const end = Date.now() + 6 * 1000;

    const colors = ['#3b3c66', '#f57d7e'];

    (function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors,
        zIndex: 20000,
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors,
        zIndex: 20000,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  createFirework() {
    const duration = 15 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);
      confetti(
        Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        }),
      );
      confetti(
        Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        }),
      );
    }, 250);
  }
}
